export default __webpack_public_path__ + "static/media/logoutIcon.e56c54b5.svg";